"use client"

import { useState, useEffect } from "react"
import { useApp } from "../../contexts/AppContext"
import Modal from "./Modal"
import { BiCheckCircle, BiX } from "react-icons/bi"

export default function ClasseurModal({ isOpen, onClose, projectId, classeurId = null }) {
    const { getClasseur, addClasseurAPI, updateClasseurAPI, setSuccess } = useApp()
    const [errors, setErrors] = useState({})
    const isEdit = Boolean(classeurId)
    const [formData, setFormData] = useState({
        libelle_classeur: "",
        note_classeur: "",
        couleur_classeur: "#007bff",
        id_projet: projectId
    })


    useEffect(() => {
        if (isEdit && classeurId) {
            const classeur = getClasseur(classeurId)
            if (classeur) {
                setFormData(classeur)
            }
        } else {
            setFormData({
                libelle_classeur: "",
                note_classeur: "",
                couleur_classeur: "#007bff",
                id_projet: projectId,
            })
        }
        setErrors({})
    }, [classeurId, isEdit, getClasseur, isOpen, projectId])


    const validateForm = () => {
        const newErrors = {}

        if (!formData.libelle_classeur.trim()) {
            newErrors.libelle_classeur = "Le libellé est obligatoire"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }


    const handleSubmit = (e) => {
        e.preventDefault()

        if (!validateForm()) return

        if (isEdit) {
            updateClasseurAPI(classeurId, formData);
            setSuccess("Classeur modifié avec succès !")
        } else {
            addClasseurAPI(formData);
            setSuccess("Classeur ajouté avec succès !")
        }
        onClose()
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })

        if (errors[name] && value.trim()) {
            setErrors({ ...errors, [name]: undefined })
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={isEdit ? "Modifier le classeur" : "Nouveau classeur"} size="lg">
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="libelle_classeur" className="form-label"> Libellé * </label>
                    <input
                        type="text"
                        className={`form-control ${errors.libelle_classeur ? "is-invalid" : ""}`}
                        id="libelle_classeur"
                        name="libelle_classeur"
                        value={formData.libelle_classeur}
                        onChange={handleChange}
                        placeholder="Nom du classeur"
                    />
                    {errors.libelle_classeur && <div className="invalid-feedback">{errors.libelle_classeur}</div>}
                </div>

                <div className="mb-3">
                    <label htmlFor="note_classeur" className="form-label"> Note </label>
                    <textarea
                        className="form-control"
                        id="note_classeur"
                        name="note_classeur"
                        rows="2"
                        value={formData.note_classeur}
                        onChange={handleChange}
                        placeholder="Description du classeur"
                    />
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="mb-3">
                            <label htmlFor="couleur_classeur" className="form-label"> Couleur </label>
                            <input
                                type="color"
                                className="form-control form-control-color w-100"
                                id="couleur_classeur"
                                name="couleur_classeur"
                                value={formData.couleur_classeur}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3">
                    <button type="button" className="btn btn-sm btn-secondary btn-sm px-2 d-flex align-items-center" onClick={onClose}>
                        <BiX className="me-1" /> Annuler
                    </button>
                    <button type="submit" className="btn btn-sm btn-primary btn-sm px-2 d-flex align-items-center">
                        <BiCheckCircle className="me-1" /> {isEdit ? "Modifier" : "Ajouter"}
                    </button>
                </div>
            </form>
        </Modal>
    )
}
